export const SELECT2_FILTRO_AVANZADO = [
    {tipoFiltro: 'SearchCliente', opcion: 1},
    {tipoFiltro: 'SearchNombreComercial', opcion: 1},
    {tipoFiltro: 'SearchSucursal', opcion: 1},
    {tipoFiltro: 'SearchEquipoSerial', opcion: 1},
    {tipoFiltro: 'SearchCodigoInterno', opcion: 1},
    {tipoFiltro: 'SearchFamilia', opcion: 1},
    {tipoFiltro: 'SearchMarca', opcion: 1},
    {tipoFiltro: 'SearchTipoAdquisicion', opcion: 1},
    // {tipoFiltro: 'SearchIncidencia', opcion: 1},
    // {tipoFiltro: 'SearchTicket', opcion: 1},
    {tipoFiltro: 'SearchEstadosPqr', opcion: 1},
    {tipoFiltro: 'SearchServicioPqr', opcion: 1},
    {tipoFiltro: 'SearchPrioridad', opcion: 1},
    {tipoFiltro: 'SearchTecnico', opcion: 1},
    {tipoFiltro: 'SearchOperacion', opcion: 1},
];

export const SELECT2_FILTRO_DASHBOARD = [
    {tipoFiltro: 'SearchCliente', opcion: 1},
    {tipoFiltro: 'SearchSucursal', opcion: 1},
    {tipoFiltro: 'SearchEquipo', opcion: 1},
    {tipoFiltro: 'SearchEquipoSerial', opcion: 1},
    {tipoFiltro: 'SearchCodigoInterno', opcion: 1},
    {tipoFiltro: 'SearchTecnico', opcion: 1},
    {tipoFiltro: 'SearchActividad', opcion: 1},
    {tipoFiltro: 'SearchOperacion', opcion: 1},
    {tipoFiltro: 'SearchInfraestructura', opcion: 1},
    {tipoFiltro: 'SearchTipoAdquisicion', opcion: 1},
    {tipoFiltro: 'SearchEstadosPqr', opcion: 1},
    {tipoFiltro: 'SearchServicioPqr', opcion: 1},
    {tipoFiltro: 'SearchPrioridad', opcion: 1},
    {tipoFiltro: 'SearchTipopqr', opcion: 1},
    {tipoFiltro: 'SearchDependencia', opcion: 1},
    {tipoFiltro: 'SearchCentroCosto', opcion: 1},
];

export const SELECT2_FILTRO_INFORME_INSUMOS = [
    {tipoFiltro: 'SearchCliente', opcion: 1},
    {tipoFiltro: 'SearchSucursal', opcion: 1},
    {tipoFiltro: 'SearchEquipo', opcion: 1},
    {tipoFiltro: 'SearchModelo', opcion: 1},
    {tipoFiltro: 'SearchEquipoSerial_2', opcion: 1},
    {tipoFiltro: 'SearchFamilia', opcion: 1},
    {tipoFiltro: 'SearchCodigoInterno', opcion: 1},
    {tipoFiltro: 'SearchMarca', opcion: 1},
    {tipoFiltro: 'SearchEstadosPqr', opcion: 1},
    {tipoFiltro: 'SearchIncidencia', opcion: 0}
];

export const SELECT2_FILTRO_FICHAS_TECNICAS = [
    {tipoFiltro: 'SearchCliente', opcion: 1},
    {tipoFiltro: 'SearchSucursal', opcion: 1},
    {tipoFiltro: 'SearchFamilia', opcion: 1},
    {tipoFiltro: 'SearchEquipoSerial', opcion: 1},
    {tipoFiltro: 'SearchCodigoInterno', opcion: 1},
    {tipoFiltro: 'SearchTipoAdquisicion', opcion: 1}
];

export const SELECT2_FILTRO_INFORME_REGISTRO_TIEMPO = [
    {tipoFiltro: 'SearchCliente', opcion: 1},
    {tipoFiltro: 'SearchTecnico', opcion: 1},
    {tipoFiltro: 'SearchTipopqr', opcion: 1},
    {tipoFiltro: 'SearchServicioPqr', opcion: 1},
    {tipoFiltro: 'SearchMedioSoporte', opcion: 1},
    {tipoFiltro: 'SearchEstadosPqr', opcion: 1},
];


// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/utilidades/constantes.ts